<template>
	<div>

		<a-modal
		      :title="form.room_id > 0 ? '编辑房间' : '新增房间'"
		      :visible="visible"
		      :confirm-loading="confirmLoading"
		      @ok="handleOk"
		      @cancel="handleCancel"
		    >
		    <a-form-model :model="form">

		      	<a-form-model-item required label="房间名称">
		      		<a-input v-model="form.name" placeholder="输入房间名称" style="width: 300px;"></a-input>
		      	</a-form-model-item>

		      	<a-form-model-item required label="房号">
		      		<a-input v-model="form.room_no" placeholder="输入房号" style="width: 300px;"></a-input>
		      	</a-form-model-item>

				<a-form-model-item required label="所属门店">
					<a-select style="width: 200px;" v-model="form.mendian_id">
						<a-select-option :value="0">请选择</a-select-option>
						<a-select-option v-for="(item,index) in mendians" :key="index" :value="item.mendian_id">{{item.name}}</a-select-option>
					</a-select>
				</a-form-model-item>

				<a-form-model-item label="房间简介">
					<a-input v-model="form.room_desc"  placeholder="输入房间简介" type="textarea"></a-input>
				</a-form-model-item>

				<a-form-model-item label="房间图片">
					<div>
						<!-- <div class="ft12 cl-notice">建议上传200x200px</div> -->
						<div class="mt12">
							<upload-img v-model="form.img_url"></upload-img>
						</div>
					</div>
				</a-form-model-item>

				<a-form-model-item label="使用中">
					<a-radio-group v-model="form.is_use">
						<a-radio :value="1">是</a-radio>
						<a-radio :value="0">否</a-radio>
					</a-radio-group>
				</a-form-model-item>

				<a-form-model-item label="是否隐私">
					<a-radio-group v-model="form.is_yin">
						<a-radio :value="1">是</a-radio>
						<a-radio :value="0">否</a-radio>
					</a-radio-group>
				</a-form-model-item>

				<a-form-model-item label="关联项目">
					<a-radio-group v-model="form.is_project">
						<a-radio :value="1">是</a-radio>
						<a-radio :value="0">否</a-radio>
					</a-radio-group>
				</a-form-model-item>

				<a-form-model-item label="状态">
					<a-radio-group v-model="form.status">
						<a-radio :value="1">正常</a-radio>
						<a-radio :value="2">关闭</a-radio>
					</a-radio-group>
				</a-form-model-item>
		      	
		    </a-form-model>	
		</a-modal>
	</div>
</template>

<script>
	import uploadImg from '../../../../components/upload/upload.vue';
	import BaiduMap from '../../../../components/map/baidumap.vue';
	export default {
		components:{
			uploadImg,
			BaiduMap
		},
		props:{
			datas:{
				type:Object,
				default:function(){
					return new Object;
				}
			},
		},
		data(){
			return {
				confirmLoading:false,
				visible:true,
				form:{},
				mendians:[],
			}
		},
		created(){
			this.form = JSON.parse(JSON.stringify(this.datas));
			this.visible = true;
			this.getMendians();
		},
		methods:{
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			selectAct(res){
				this.form.lng = res.lng;
				this.form.lat = res.lat;
			},
			handleOk(){
				if(this.confirmLoading == true) return;
				this.confirmLoading = true;
				this.$http.api('admin/saveRoom',{
					room_id:this.form.room_id,
					name:this.form.name,
					room_no	:this.form.room_no,
					mendian_id	:this.form.mendian_id,
					room_desc	:this.form.room_desc,
					img_url	:this.form.img_url,
					is_use:this.form.is_use,
					is_yin:this.form.is_yin,
					is_project:this.form.is_project,
					status	:this.form.status,
				}).then(res=>{
					this.$message.success('操作成功');
					this.confirmLoading = false;
					this.visible = false;
					this.$emit('ok');
				}).catch(res=>{
					this.confirmLoading=false;
				})
			},
			handleCancel(){
				this.visible = false;
				this.$emit('closed');
			}
		}
	}
</script>

<style>
	
</style>